import { http } from '../../config/axios'

export default function putClient(client: any): Promise<string> {
  return http
    .put('api/client', client)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post client', error)
      throw Error(error.response.data)
    })
}
